// @ts-nocheck
import { OutlinedInput, InputAdornment } from "@mui/material";
import { styled } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";

const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  borderRadius: "0.5rem",
  height: "3rem",
  border: `1px solid ${getCssVariableHandler({ variableName: "--primary-pink-hex" })}`,
  color: theme.palette.common.white,
  transition: "border-color 0.2s ease-in-out",

  "&:hover": {
    borderColor: getCssVariableHandler({ variableName: "--primary-pink-hex" }), // Keeps border same on hover
  },

  "&.Mui-focused": {
    borderColor: getCssVariableHandler({ variableName: "--primary-pink-hex" }), // No extra focus effect
    boxShadow: "none", // Removes any extra glow
    outline: "none",
  },

  "&.Mui-focused fieldset": {
    outline: "none",
    border: "none",
  },

  "& .MuiInputAdornment-root": {
    color: getCssVariableHandler({ variableName: "--primary-pink-hex" }), // Ensures icon matches border color
  },
}));

/**
 * component which return the search input
 * @typedef {import("@mui/material").OutlinedInputProps} OutlinedInputProps
 * @param {OutlinedInputProps} props - Props for MUI OutlinedInput.
 * @returns {React.JSX}
 */
export default function SheetSearchInput(props) {
  return (
    <StyledOutlinedInput
      {...props}
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      }
      placeholder="Search..."
    />
  );
}